module.exports = __webpack_public_path__ + "img/亮点3_03.d0b73a9c.jpg";